(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sscc-squid-quiz-v1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get("squidgo-quiz-v8-v3")) {
  customElements.define(
    "squidgo-quiz-v8-v3",
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (this.onPageShow)
            window.addEventListener("pageshow", this.onPageShow);
          return;
        }
        this.initialized = true;
        const root = this;
        const byId = (id) => root.querySelector("#sqv8v3-" + id);
        const config = JSON.parse(
          root.querySelector("[data-quiz-config]").textContent,
        );
        const productUrls = config.products;
        const emailHome = root.querySelector("[data-email-home]");
        const emailOffer = root.querySelector("[data-email-offer]");
        let scrollWasLocked = false,
          previousOverflow = "";
        const lockScroll = () => {
          if (!scrollWasLocked) {
            previousOverflow = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            scrollWasLocked = true;
          }
        };
        const unlockScroll = () => {
          if (scrollWasLocked) {
            document.body.style.overflow = previousOverflow;
            scrollWasLocked = false;
          }
        };
        root.querySelectorAll("[data-trustpilot-logo]").forEach((image) => {
          image.src =
            "https://cdn.trustpilot.net/brand-assets/4.1.0/logo-black.svg";
        });
        const STORE = window.location.origin;
        const SUPPORT_EMAIL = "support@mygymdelivered.com";
        const COLLECTION = root.dataset.collectionUrl;
        const PRODUCTS = {
          leg: {
            label: "Leg & knee",
            name: "Leg & Knee System",
            handle: "squid-go-leg-knee-full-unit",
            description: "A complete system with a wrap for the leg and knee.",
            fit: "Use the leg-wrap measuring instructions and size guide on the product page before choosing your size.",
          },
          shoulder: {
            label: "Shoulder",
            name: "Shoulder System",
            handle: "squid-go-shoulder-full-unit",
            description:
              "A complete system with a wrap shaped for the shoulder.",
            fit: "Check the size guide and choose the correct left or right shoulder option on the product page.",
          },
          ankle: {
            label: "Ankle",
            name: "Ankle System",
            handle: "squid-go-ankle-full-unit",
            description: "A complete system with a wrap shaped for the ankle.",
            fit: "Check the ankle-wrap sizing and fitting guidance on the product page before ordering.",
          },
          elbow: {
            label: "Elbow",
            name: "Elbow System",
            handle: "squid-go-elbow-full-unit",
            description: "A complete system with a dedicated elbow wrap.",
            fit: "Check the elbow-wrap fitting guidance on the product page. Ask our team if you’re unsure about the fit.",
          },
          wrist: {
            label: "Wrist",
            name: "Wrist System",
            handle: "squid-go-wrist-full-unit",
            description: "A complete system with a dedicated wrist wrap.",
            fit: "Check the wrist-wrap sizing and fitting guidance on the product page before ordering.",
          },
          back: {
            label: "Back",
            name: "Back System",
            handle: "squid-go-back-full-unit",
            description: "A complete system with a wrap for the back.",
            fit: "Use the back-wrap measuring instructions and size guide on the product page before ordering.",
          },
        };
        const ICONS = {
          arrow: '<path d="M4 12h15m-6-6 6 6-6 6"/>',
          back: '<path d="M20 12H5m6-6-6 6 6 6"/>',
          check: '<path d="m5 12 4 4L19 6"/>',
          home: '<path d="m3 10 9-7 9 7M5 9v12h14V9M9 21v-7h6v7"/>',
          travel:
            '<rect x="4" y="7" width="16" height="13" rx="2"/><path d="M9 7V4h6v3M8 11v5m8-5v5M8 20v1m8-1v1"/>',
          desk: '<path d="M3 12h18M5 12v9m14-9v9M7 4h10v8H7zM3 16h18"/>',
          spark:
            '<path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z"/>',
          snow: '<path d="M12 2v20M3.3 7l17.4 10M3.3 17 20.7 7M9 4l3 3 3-3M9 20l3-3 3 3M4 10l4-1-1-4M17 19l-1-4 4-1M4 14l4 1-1 4M17 5l-1 4 4 1"/>',
          box: '<path d="m3 7 9-4 9 4v10l-9 4-9-4V7Zm0 0 9 4 9-4m-9 4v10M7 5l10 4"/>',
          measure:
            '<path d="m3 16 13-13 5 5L8 21l-5-5ZM13 6l2 2m-5 1 2 2m-5 1 2 2m-5 1 2 2"/>',
          play: '<circle cx="12" cy="12" r="9"/><path d="m10 8 6 4-6 4V8Z"/>',
          help: '<path d="M9 8a3 3 0 1 1 5 2.3c-1.5.6-2 1.2-2 2.7M12 17v.1"/><circle cx="12" cy="12" r="9"/>',
          person:
            '<circle cx="12" cy="7" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/>',
          shield:
            '<path d="m12 3 8 3v6c0 4-5 8-8 9-3-1-8-5-8-9V6l8-3Z"/><path d="m8 12 3 3 5-6"/>',
        };
        const icon = (name) =>
          `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICONS[name]}</svg>`;
        const areaArt = (area) => {
          const body =
            '<circle cx="40" cy="12" r="7"/><path d="M34 22h12c7 0 10 4 12 11l6 17c1 5-4 7-6 2l-7-15-2 18 3 18c1 5-5 6-6 1l-6-17-6 17c-1 5-7 4-6-1l3-18-2-18-7 15c-2 5-7 3-6-2l6-17c2-7 5-11 12-11Z"/>';
          const points = {
            leg: [35, 61],
            shoulder: [51, 27],
            ankle: [31, 73],
            elbow: [59, 43],
            wrist: [63, 52],
            back: [40, 44],
            unsure: [40, 44],
          };
          const [x, y] = points[area] || points.unsure;
          return `<svg class="area-art" viewBox="0 0 80 82" fill="none" aria-hidden="true"><g stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">${body}</g><circle cx="${x}" cy="${y}" r="10" fill="#dbe9fc"/><circle cx="${x}" cy="${y}" r="4.5" fill="#1a66d2"/></svg>`;
        };
        const SIZED_AREAS = ["leg", "shoulder", "ankle"];
        const QUESTIONS = {
          area: {
            id: "area",
            title: "Which area are you shopping for?",
            description: "Choose one area to start.",
            type: "areas",
            options: [
              ...Object.entries(PRODUCTS).map(([value, p]) => ({
                value,
                label: p.label,
              })),
              {
                value: "unsure",
                label: "I’m not sure yet",
              },
            ],
          },
          profile: {
            id: "profile",
            title: "Which best describes you?",
            description: "Choose the one that sounds most like you.",
            type: "profile",
            options: [
              {
                value: "sport",
                label: "Sport and training",
                description: "I exercise or play sport regularly.",
                icon: "spark",
              },
              {
                value: "active",
                label: "Staying active day to day",
                description: "Walking, hobbies and everyday movement.",
                icon: "home",
              },
              {
                value: "work",
                label: "Physically demanding work",
                description: "Lifting, carrying or working with my hands.",
                icon: "desk",
              },
              {
                value: "recovery",
                label: "Following a recovery plan",
                description: "I’m following guidance from my care team.",
                icon: "shield",
              },
              {
                value: "care",
                label: "Choosing for someone else",
                description: "I’m helping a friend or family member.",
                icon: "person",
              },
              {
                value: "clinic",
                label: "Clinic or commercial enquiry",
                description: "Help choosing from the Squid Go Pro lineup.",
                icon: "box",
              },
              {
                value: "explore",
                label: "Just exploring",
                description: "I’d like to learn what’s available.",
                icon: "help",
              },
            ],
          },
          experience: {
            id: "experience",
            title: "Have you tried cold compression before?",
            description: "Choose the answer that sounds most like you.",
            options: [
              {
                value: "new",
                label: "I’m new to it",
                description: "I’d like to understand the basics.",
                icon: "spark",
              },
              {
                value: "ice",
                label: "I use ice or gel packs",
                description: "I’m curious about adding compression.",
                icon: "snow",
              },
              {
                value: "owner",
                label: "I already own a Squid Go system",
                description: "I’m looking for a wrap, gel pack or part.",
                icon: "box",
              },
            ],
          },
          routine: {
            id: "routine",
            title: "Where would you mainly use it?",
            description: "We’ll explain what you’d need for the setup.",
            options: [
              {
                value: "home",
                label: "At home",
                description: "During a break on the sofa or in a chair.",
                icon: "home",
              },
              {
                value: "desk",
                label: "At a desk",
                description: "During a seated break at work.",
                icon: "desk",
              },
              {
                value: "away",
                label: "Away from home",
                description: "I’d like to know what to bring.",
                icon: "travel",
              },
            ],
          },
        };
        const PROFILE_COPY = {
          sport: {
            heading: "For your training routine",
            text: "Plan around a frozen gel pack and a charged pump, so the system is ready when you sit down for a break.",
          },
          active: {
            heading: "For your everyday routine",
            text: "Keep the setup somewhere convenient, with access to a freezer for the gel pack.",
          },
          work: {
            heading: "For physically demanding work",
            text: "Allow time to prepare the gel pack, then use the system during a seated break.",
          },
          recovery: {
            heading: "Alongside your recovery plan",
            text: "Follow your care team’s guidance on whether and how to use cold compression. The quiz selects a product and fit, not a treatment plan.",
          },
          care: {
            heading: "For the person you’re helping",
            text: "Use their measurements and the side they need. Check that they can follow the supplied setup and fitting instructions.",
          },
          clinic: {
            heading: "For clinic or commercial enquiries",
            text: "Email us for a referral to the sales team, who can help select a suitable system from the Squid Go Pro lineup.",
          },
          explore: {
            heading: "A useful place to start",
            text: "See how the system works, what comes in the box and which fit options are available.",
          },
        };
        const VIDEOS = {
          works: {
            label: "How Squid Go works",
            src: "https://player.vimeo.com/video/318258441?badge=0&autopause=1&autoplay=0&dnt=1",
          },
          doctor: {
            label: "Dr. Ryley on Squid Go",
            src: "https://player.vimeo.com/video/503596982?h=ffdbb370df&autopause=1&autoplay=0&dnt=1",
          },
          leg: {
            label: "Leg/knee system",
            src: "https://player.vimeo.com/video/611302278?h=9b64dd66f6&autopause=1&autoplay=0&dnt=1",
          },
          ankle: {
            label: "Ankle system",
            src: "https://player.vimeo.com/video/547306785?h=9c5a61f6ce&autopause=1&autoplay=0&dnt=1",
          },
          shoulder: {
            label: "Shoulder system",
            src: "https://player.vimeo.com/video/611284822?h=557864b962&autopause=1&autoplay=0&dnt=1",
          },
          elbow: {
            label: "Elbow system",
            src: "https://player.vimeo.com/video/647468922?h=e30ab93e23&autopause=1&autoplay=0&dnt=1",
          },
          wrist: {
            label: "Wrist system",
            src: "https://player.vimeo.com/video/593346872?h=dd7a9c2778&autopause=1&autoplay=0&dnt=1",
          },
          back: {
            label: "Back system",
            src: "https://player.vimeo.com/video/644992170?h=7116bd2e1b&autopause=1&autoplay=0&dnt=1",
          },
        };
        const emptySizing = () => ({
          value: "",
          unit: "in",
          shoe: "",
          side: "",
          skip: false,
        });
        const state = {
          step: 0,
          answers: {},
          sizing: emptySizing(),
          videoKind: "system",
          videoArea: "leg",
        };
        const intro = byId("intro"),
          quiz = byId("quiz"),
          result = byId("result");
        let activeScreen = "intro";
        let requestSent = false;
        const storageKey =
          "squidgo:quiz:v8:" +
          root.dataset.sectionId +
          ":" +
          window.location.pathname;
        const storageTTL = 24 * 60 * 60 * 1000;
        function saveProgress() {
          try {
            sessionStorage.setItem(
              storageKey,
              JSON.stringify({
                version: 1,
                savedAt: Date.now(),
                screen: activeScreen,
                step: state.step,
                answers: state.answers,
                sizing: state.sizing,
                requestSent,
              }),
            );
          } catch {}
        }
        function readProgress() {
          try {
            const saved = JSON.parse(sessionStorage.getItem(storageKey));
            if (
              !saved ||
              saved.version !== 1 ||
              !Number.isFinite(saved.savedAt) ||
              Date.now() - saved.savedAt > storageTTL ||
              saved.savedAt > Date.now() + 60000
            )
              return null;
            const answers = {};
            for (const [key, question] of Object.entries(QUESTIONS)) {
              if (
                question.options.some(
                  (option) => option.value === saved.answers?.[key],
                )
              )
                answers[key] = saved.answers[key];
            }
            const sizing = emptySizing(),
              stored = saved.sizing || {};
            if (
              typeof stored.value === "string" &&
              stored.value.length <= 20 &&
              (stored.value === "" || Number.isFinite(Number(stored.value)))
            )
              sizing.value = stored.value;
            if (["in", "cm"].includes(stored.unit)) sizing.unit = stored.unit;
            if (["", "men", "women"].includes(stored.shoe))
              sizing.shoe = stored.shoe;
            if (["", "left", "right", "unsure"].includes(stored.side))
              sizing.side = stored.side;
            sizing.skip = stored.skip === true;
            return {
              answers,
              sizing,
              step: Number.isInteger(saved.step) ? saved.step : 0,
              screen: ["intro", "quiz", "result"].includes(saved.screen)
                ? saved.screen
                : "intro",
              requestSent: saved.requestSent === true,
            };
          } catch {
            return null;
          }
        }
        const reviewsDialog = byId("review-dialog");
        const terms = byId("trial-terms"),
          contact = byId("contact-dialog"),
          copyEmailButton = byId("copy-email");
        let copyResetTimer,
          copyOperation = 0;
        const escape = (value) =>
          String(value).replace(
            /[&<>"']/g,
            (c) =>
              ({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
              })[c],
          );
        function flow() {
          return [
            QUESTIONS.area,
            ...(SIZED_AREAS.includes(state.answers.area)
              ? [
                  {
                    id: "fit",
                  },
                ]
              : []),
            QUESTIONS.profile,
            ...(state.answers.profile === "clinic"
              ? []
              : [QUESTIONS.experience, QUESTIONS.routine]),
          ];
        }
        function continueLabel() {
          return flow()[state.step].id === "profile" &&
            state.answers.profile === "clinic"
            ? "See contact details"
            : state.step === flow().length - 1
              ? "See my guide"
              : "Continue";
        }
        function stopVideo() {
          byId("video-player")?.remove();
        }
        function display(target, focusId) {
          activeScreen =
            target === result ? "result" : target === quiz ? "quiz" : "intro";
          saveProgress();
          if (emailOffer && target !== result) {
            emailHome.append(emailOffer);
            emailOffer.hidden = true;
          }
          if (target !== result) stopVideo();
          [intro, quiz, result].forEach((el) => {
            el.hidden = el !== target;
          });
          root.scrollIntoView({
            block: "start",
            behavior: "instant",
          });
          if (focusId) {
            const h = byId(focusId);
            h.setAttribute("tabindex", "-1");
            h.focus({
              preventScroll: true,
            });
          }
        }
        function selectedLabel(id) {
          return (
            QUESTIONS[id]?.options.find((o) => o.value === state.answers[id])
              ?.label || ""
          );
        }
        function rangeMatch(value, ranges) {
          return ranges
            .filter(
              (r) => value >= r.min - 0.000001 && value <= r.max + 0.000001,
            )
            .map((r) => r.name);
        }
        function fitOutcome() {
          const area = state.answers.area,
            s = state.sizing;
          if (!PRODUCTS[area])
            return {
              status: "unknown",
              size: "Choose a body area",
              detail: "Our team can help you explore the wrap options.",
              resolved: false,
            };
          if (!SIZED_AREAS.includes(area))
            return {
              status: "matched",
              size: "One size fits most",
              detail:
                "This system uses a one-size wrap. Check the product’s fit guidance before ordering.",
              resolved: true,
            };
          if (s.skip)
            return {
              status: "unknown",
              size: "Size to confirm",
              detail:
                "Check your measurement or ask our team before choosing a size.",
              resolved: false,
            };
          const number = Number(s.value);
          if (
            s.value.trim() === "" ||
            !Number.isFinite(number) ||
            number <= 0 ||
            (area === "ankle" && !s.shoe)
          )
            return {
              status: "pending",
              size: "Size to confirm",
              detail:
                area === "ankle"
                  ? "Choose a shoe-size chart and enter your US shoe size."
                  : "Enter your measurement to see the fit guidance.",
              resolved: false,
            };
          const value =
            area === "ankle"
              ? number
              : s.unit === "cm"
                ? number / 2.54
                : number;
          const ranges =
            area === "leg"
              ? [
                  {
                    name: "Regular",
                    min: 14,
                    max: 22,
                  },
                  {
                    name: "Large",
                    min: 23,
                    max: 34,
                  },
                ]
              : area === "shoulder"
                ? [
                    {
                      name: "Regular",
                      min: 32,
                      max: 45,
                    },
                    {
                      name: "Large",
                      min: 45,
                      max: 57,
                    },
                  ]
                : s.shoe === "men"
                  ? [
                      {
                        name: "Regular",
                        min: 7,
                        max: 13,
                      },
                      {
                        name: "Large",
                        min: 13,
                        max: 20,
                      },
                    ]
                  : [
                      {
                        name: "Regular",
                        min: 6,
                        max: 14,
                      },
                      {
                        name: "Large",
                        min: 14,
                        max: 20,
                      },
                    ];
          const matches = rangeMatch(value, ranges);
          const measurement =
            area === "ankle"
              ? `${s.shoe === "men" ? "Men’s" : "Women’s"} US shoe size ${number}`
              : `${number} ${s.unit === "cm" ? "cm" : "inches"} ${area === "leg" ? "around mid-thigh" : "around the chest"}`;
          if (matches.length === 2)
            return {
              status: "matched",
              size: "Regular",
              detail: `${measurement} is on the boundary between sizes. The wrap works best snug, so choose Regular.`,
              resolved:
                area !== "shoulder" || ["left", "right"].includes(s.side),
            };
          if (matches.length === 0)
            return {
              status: "outside",
              size: "Size needs a fit check",
              detail: `${measurement} is outside the listed ranges or in a gap between them. Ask our team before ordering.`,
              resolved: false,
            };
          const sideReady =
            area !== "shoulder" || ["left", "right"].includes(s.side);
          return {
            status: "matched",
            size: matches[0],
            detail: `${measurement} falls in the ${matches[0]} range.`,
            resolved: sideReady,
          };
        }
        function fitCanContinue() {
          return (
            fitOutcome().status !== "pending" &&
            (state.answers.area !== "shoulder" || !!state.sizing.side)
          );
        }
        function variantLabel(fit) {
          return state.answers.area === "shoulder"
            ? `${fit.size} · ${state.sizing.side === "left" ? "Left shoulder" : state.sizing.side === "right" ? "Right shoulder" : "Side to confirm"}`
            : fit.size;
        }
        function sizingChart(area) {
          if (area === "leg")
            return "<p><strong>Regular:</strong> 14 to 22 inches around mid-thigh</p><p><strong>Large:</strong> 23 to 34 inches around mid-thigh</p><p>Fits either leg.</p>";
          if (area === "shoulder")
            return "<p><strong>Regular:</strong> 32 to 45 inches around the chest</p><p><strong>Large:</strong> 45 to 57 inches around the chest</p><p>Sold individually. Choose left or right.</p><p>The wrap works best snug, so pick Regular if you land on the boundary.</p>";
          return "<p><strong>Regular:</strong> Men’s US 7 to 13 · Women’s US 6 to 14</p><p><strong>Large:</strong> Men’s US 13 to 20 · Women’s US 14 to 20</p><p>Fits either ankle.</p><p>The wrap works best snug, so pick Regular if you land on the boundary.</p>";
        }
        function questionTop() {
          const total = flow().length;
          return `<div class="quiz-top"><button type="button" class="back" id="sqv8v3-back">${icon("back")} Back</button><p class="step-count"><strong>Question ${state.step + 1}</strong><span class="question-count-tail">${state.answers.area ? " of " + total : ""}</span></p></div><div class="progress" role="progressbar" aria-label="Quiz progress" aria-valuemin="0" aria-valuemax="${total}" aria-valuenow="${state.step}" aria-valuetext="Question ${state.step + 1}${state.answers.area ? " of " + total : ""}">${Array.from(
            {
              length: total,
            },
            (_, i) => `<span class="${i < state.step ? "done" : ""}"></span>`,
          ).join("")}</div>`;
        }
        function wireBack() {
          byId("back").addEventListener("click", () => {
            if (state.step === 0) display(intro, "intro-title");
            else {
              state.step--;
              renderQuestion();
            }
          });
        }
        function advance() {
          if (state.step < flow().length - 1) {
            state.step++;
            renderQuestion();
          } else renderResult();
        }
        function renderQuestion() {
          const q = flow()[state.step];
          if (q.id === "fit") {
            renderFitQuestion();
            return;
          }
          quiz.innerHTML = `${questionTop()}<div class="question-header"><h2 id="sqv8v3-question-title">${q.title}</h2><p class="question-copy">${q.description}</p></div><form id="sqv8v3-question-form"><fieldset class="choices ${q.type === "areas" ? "area-grid" : q.type === "profile" ? "profile-grid" : "list-grid"}"><legend class="sr-only">${q.title}</legend>${q.options
            .map((o) => {
              const inside =
                q.type === "areas"
                  ? `${o.value === "unsure" ? `<span class="area-art">${icon("help")}</span>` : areaArt(o.value)}<span class="area-title">${escape(o.label)}</span>`
                  : `<span class="option-icon">${icon(o.icon)}</span><span><span class="list-title">${escape(o.label)}</span><span class="list-description">${escape(o.description)}</span></span>`;
              return `<label class="option ${o.value === "unsure" ? "wide-option" : ""}"><input type="radio" name="${q.id}" value="${o.value}" ${state.answers[q.id] === o.value ? "checked" : ""} required><span class="answer ${q.type === "areas" ? "area-answer" : "list-answer"}">${inside}<span class="checkmark">${icon("check")}</span></span></label>`;
            })
            .join(
              "",
            )}</fieldset><div class="quiz-actions"><button type="submit" class="button" id="sqv8v3-continue" ${state.answers[q.id] ? "" : "disabled"}>${continueLabel()}${icon("arrow")}</button><p class="selection-hint" id="sqv8v3-selection-hint" aria-live="polite">${state.answers[q.id] ? "You can change your answer." : "Select one answer to continue."}</p></div></form>`;
          wireBack();
          byId("question-form").addEventListener("change", (event) => {
            if (!event.target.matches('input[type="radio"]')) return;
            if (q.id === "area" && state.answers.area !== event.target.value)
              state.sizing = emptySizing();
            state.answers[q.id] = event.target.value;
            byId("continue").disabled = false;
            byId("continue").innerHTML = continueLabel() + icon("arrow");
            byId("selection-hint").textContent = "You can change your answer.";
            const total = flow().length;
            root.querySelector(".question-count-tail").textContent =
              " of " + total;
            const progress = root.querySelector(".progress");
            progress.setAttribute("aria-valuemax", total);
            progress.setAttribute(
              "aria-valuetext",
              `Question ${state.step + 1} of ${total}`,
            );
            progress.innerHTML = Array.from(
              {
                length: total,
              },
              (_, i) => `<span class="${i < state.step ? "done" : ""}"></span>`,
            ).join("");
          });
          byId("question-form").addEventListener("submit", (event) => {
            event.preventDefault();
            if (state.answers[q.id]) advance();
          });
          display(quiz, "question-title");
        }
        function compactChoice(name, value, label, selected) {
          return `<label class="compact-choice"><input type="radio" name="${name}" value="${value}" ${selected ? "checked" : ""}><span>${label}</span></label>`;
        }
        function renderFitQuestion() {
          const area = state.answers.area,
            s = state.sizing,
            ankle = area === "ankle",
            shoulder = area === "shoulder";
          quiz.innerHTML = `${questionTop()}<div class="question-header"><h2 id="sqv8v3-question-title">Let’s check the ${ankle ? "ankle" : shoulder ? "shoulder" : "leg & knee"} fit.</h2><p class="question-copy">${ankle ? "Use your US shoe size to check the chart." : shoulder ? "Measure around the chest, then choose the shoulder." : "Measure around the middle of the thigh."}</p></div><form id="sqv8v3-fit-form" class="fit-form"><div class="fit-panel">${ankle ? `<fieldset class="fit-side shoe-chart-choice"><legend class="field-heading">Which shoe-size chart do you use?</legend><div class="compact-choices">${compactChoice("shoe", "men", "Men’s US", s.shoe === "men")}${compactChoice("shoe", "women", "Women’s US", s.shoe === "women")}</div></fieldset>` : ""}<label class="field-heading" for="sqv8v3-fit-value">${ankle ? "Your US shoe size" : shoulder ? "Chest circumference" : "Mid-thigh circumference"}</label><div class="measure-row"><input id="sqv8v3-fit-value" class="measure-input" type="number" min="0.1" step="any" inputmode="decimal" value="${escape(s.value)}" placeholder="${ankle ? "e.g. 9" : shoulder ? "e.g. 40" : "e.g. 20"}" aria-describedby="sqv8v3-fit-help sqv8v3-fit-feedback" ${s.skip ? "disabled" : "required"}>${ankle ? "" : `<select id="sqv8v3-fit-unit" class="unit-select" aria-label="Measurement unit" ${s.skip ? "disabled" : ""}><option value="in" ${s.unit === "in" ? "selected" : ""}>inches</option><option value="cm" ${s.unit === "cm" ? "selected" : ""}>cm</option></select>`}</div><p class="fit-help" id="sqv8v3-fit-help">${ankle ? "Use the wearer’s shoe size. This chart uses US sizing." : "Use a flexible measuring tape and enter the number you see on it."}</p><div class="size-chart">${sizingChart(area)}</div><label class="fit-skip"><input type="checkbox" id="sqv8v3-fit-skip" ${s.skip ? "checked" : ""}>I’ll check the ${ankle ? "shoe size" : "measurement"} later</label>${shoulder ? `<fieldset class="fit-side"><legend class="field-heading">Which shoulder?</legend><div class="compact-choices">${compactChoice("side", "left", "Left", s.side === "left")}${compactChoice("side", "right", "Right", s.side === "right")}${compactChoice("side", "unsure", "I’ll check", s.side === "unsure")}</div></fieldset>` : ""}<p class="fit-feedback" id="sqv8v3-fit-feedback" aria-live="polite"></p></div><div class="quiz-actions"><button type="submit" class="button" id="sqv8v3-continue">Continue${icon("arrow")}</button><p class="selection-hint">You can ask our team if the chart doesn’t give a clear fit.</p></div></form>`;
          wireBack();
          const form = byId("fit-form"),
            field = byId("fit-value");
          const update = () => {
            const fit = fitOutcome(),
              note = byId("fit-feedback");
            note.textContent =
              fit.detail +
              (shoulder && !s.side
                ? " Choose a shoulder, or select “I’ll check.”"
                : "");
            note.dataset.kind = ["outside", "overlap", "unknown"].includes(
              fit.status,
            )
              ? "check"
              : "normal";
            byId("continue").disabled = !fitCanContinue();
          };
          field.addEventListener("input", () => {
            s.value = field.value;
            update();
          });
          form.addEventListener("change", (event) => {
            const el = event.target;
            if (el.id === "sqv8v3-fit-skip") {
              s.skip = el.checked;
              field.disabled = s.skip;
              field.required = !s.skip;
              if (byId("fit-unit")) byId("fit-unit").disabled = s.skip;
            } else if (el.id === "sqv8v3-fit-unit") {
              s.unit = el.value;
              s.value = "";
              field.value = "";
              field.placeholder =
                s.unit === "cm"
                  ? shoulder
                    ? "e.g. 100"
                    : "e.g. 50"
                  : shoulder
                    ? "e.g. 40"
                    : "e.g. 20";
            } else if (el.name === "shoe") {
              s.shoe = el.value;
            } else if (el.name === "side") {
              s.side = el.value;
            }
            update();
          });
          form.addEventListener("submit", (event) => {
            event.preventDefault();
            if (fitCanContinue()) advance();
          });
          update();
          display(quiz, "question-title");
        }
        function purchaseBenefits(showTrial = true) {
          return `<section class="purchase-benefits" aria-label="Shopping with My Gym Delivered"><p class="benefits-retailer">With My Gym Delivered</p>${showTrial ? '<div class="trial-highlight"><div class="benefit-mark"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m12 3 8 3v6c0 4-5 8-8 9-3-1-8-5-8-9V6l8-3Z"/><path d="m8 12 3 3 5-6"/></svg></div><div><strong>30-day trial*</strong><span>On complete Squid Go systems</span><p>*From purchase date. Return terms apply.</p><button type="button" class="inline-button" data-trial-details aria-haspopup="dialog" aria-controls="sqv8v3-trial-terms">View trial terms</button></div></div>' : ""}<div class="shipping-highlight"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h11v12H3zM14 9h4l3 4v4h-7M3 17h2m5 0h5m5 0h1"/><circle cx="7.5" cy="17.5" r="2.5" fill="#fff"/><circle cx="17.5" cy="17.5" r="2.5" fill="#fff"/></svg><div><strong>Free shipping on orders $75+</strong><span>Standard shipping in the contiguous 48 states.</span></div></div></section>`;
        }
        const REVIEW_SOURCE = "https://www.trustpilot.com/review/squidgo.co.uk";
        const REVIEWS = [
          {
            name: "Nicholas D.",
            date: "June 2026",
            rating: 5,
            title: "Convenient to use",
            summary:
              "Valued using the system without loose ice or a nearby power outlet.",
            url: "https://www.trustpilot.com/reviews/6a31967a54c74f8372f8502c",
          },
          {
            name: "Craig P.",
            date: "June 2026",
            rating: 5,
            title: "A compact, portable setup",
            summary:
              "Liked the palm-sized pump and freezer gel packs. Would prefer a clearer charging indicator.",
            url: "https://www.trustpilot.com/reviews/6a4259ffaaeeb825a9bf7ce9",
          },
          {
            name: "James S.",
            date: "August 2026",
            rating: 4,
            title: "Feedback on the hardware",
            summary:
              "Liked the product, but felt the price was high and would prefer USB-C charging.",
            url: "https://www.trustpilot.com/reviews/6a8b5d4931924374881fa744",
          },
        ];
        function reviewsSection() {
          return `<section class="owner-reviews" aria-labelledby="sqv8v3-reviews-title"><div class="reviews-heading"><h3 id="sqv8v3-reviews-title">What Squid Go owners say</h3><img class="trustpilot-logo" src="https://cdn.trustpilot.net/brand-assets/4.1.0/logo-black.svg" alt="Trustpilot" width="113" height="28" loading="lazy"></div><p class="reviews-source">Selected review summaries from Squid Go’s UK Trustpilot profile (squidgo.co.uk).</p><div class="review-grid">${REVIEWS.map((review, index) => `<article class="owner-review"><div class="review-meta"><span class="review-name">${review.name}</span><img src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${review.rating}.svg" alt="${review.rating} out of 5 stars" width="90" height="17" loading="lazy"></div><h4>${review.title}</h4><p>${review.summary}</p><div class="review-bottom"><span>${review.date}</span><button type="button" class="inline-button" data-review="${index}" aria-label="View ${review.name} review on Trustpilot" aria-haspopup="dialog" aria-controls="sqv8v3-review-dialog">View on Trustpilot ↗</button></div></article>`).join("")}</div><p class="reviews-disclosure">Summarised in our own words. These reviews describe Squid Go purchases through the UK seller.</p></section>`;
        }
        function boxContents(area) {
          const sleeve = ["leg", "elbow", "wrist"].includes(area);
          const barrier = sleeve
            ? "Use the <strong>included barrier sleeve</strong>."
            : area === "ankle"
              ? "Wear a <strong>sock</strong> under the ankle wrap. A sock is not included."
              : ["back", "shoulder"].includes(area)
                ? "Wear a <strong>T-shirt</strong> under the wrap. A T-shirt is not included."
                : "Leg/knee, elbow and wrist systems include a barrier sleeve. Wear a sock with the ankle wrap, or a T-shirt with the shoulder or back wrap.";
          return `<section class="kit-section" aria-labelledby="sqv8v3-kit-title"><h3 id="sqv8v3-kit-title">Inside your full system</h3><ul class="kit-grid">${["Squid Go control unit (pump)", "Charger and connector tube", `${PRODUCTS[area] ? PRODUCTS[area].label + " wrap" : "Your chosen wrap"} and its matching gel pack`, "User manual and quick start guide", ...(sleeve ? ["Barrier sleeve"] : [])].map((item) => `<li>${icon("check")}<span>${escape(item)}</span></li>`).join("")}</ul><p class="kit-barrier">${barrier}</p></section>`;
        }
        function videoSection(area) {
          return `<section class="video-section" aria-labelledby="sqv8v3-video-title"><h3 id="sqv8v3-video-title">See it in action.</h3><div class="video-choices" role="group" aria-label="Choose a video"><button type="button" class="video-choice" data-video="system" aria-pressed="true">${PRODUCTS[area] ? "Your system" : "Product videos"}</button><button type="button" class="video-choice" data-video="works" aria-pressed="false">How it works</button><button type="button" class="video-choice" data-video="doctor" aria-pressed="false">Dr. Ryley</button></div><div class="video-picker" id="sqv8v3-video-picker"><label for="sqv8v3-video-system">System video</label><select class="video-select" id="sqv8v3-video-system">${Object.entries(
            PRODUCTS,
          )
            .map(
              ([id, p]) =>
                `<option value="${id}" ${id === state.videoArea ? "selected" : ""}>${p.label}</option>`,
            )
            .join(
              "",
            )}</select></div><div class="video-frame" id="sqv8v3-video-frame"></div><p class="video-caption" id="sqv8v3-video-caption"></p><a class="video-external" id="sqv8v3-video-external" href="#" target="_blank" rel="noopener noreferrer">Open this video in a new tab ↗</a></section>`;
        }
        function showVideo() {
          const key =
              state.videoKind === "system" ? state.videoArea : state.videoKind,
            v = VIDEOS[key];
          root
            .querySelectorAll("[data-video]")
            .forEach((button) =>
              button.setAttribute(
                "aria-pressed",
                String(button.dataset.video === state.videoKind),
              ),
            );
          byId("video-picker").hidden = state.videoKind !== "system";
          byId("video-frame").innerHTML =
            `<iframe id="sqv8v3-video-player" src="${escape(v.src)}" title="${escape(v.label)}" loading="eager" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
          byId("video-caption").textContent =
            state.videoKind === "system"
              ? `A closer look at the ${PRODUCTS[state.videoArea].label.toLowerCase()} system.`
              : state.videoKind === "doctor"
                ? "Dr. Ryley on Squid Go."
                : state.answers.area === "shoulder"
                  ? "This short animation shows sequential compression. The shoulder wrap uses non-sequential compression."
                  : "A short visual explanation of sequential compression, without narration.";
          byId("video-external").href = v.src;
        }
        function renderClinicReferral() {
          stopVideo();
          const emailLink =
            "mailto:" +
            SUPPORT_EMAIL +
            "?subject=" +
            encodeURIComponent("Squid Go Pro enquiry");
          result.innerHTML = `<div class="result-top"><span class="completed">${icon("person")}Your enquiry</span><button type="button" class="text-button" id="sqv8v3-clinic-edit">Change my answer</button></div><div class="result-header"><h2 id="sqv8v3-result-title">Explore the Squid Go Pro lineup.</h2><p>For clinic or commercial use, email us. We’ll refer you to the sales team to help select a suitable system from the Squid Go Pro lineup.</p></div><section class="clinic-notice" aria-labelledby="sqv8v3-clinic-notice-title"><h3 id="sqv8v3-clinic-notice-title">Squid Go is intended for personal use.</h3><p>Use in a commercial setting immediately voids the warranty for the pump, wrap, tube connector, gel pack and battery charger.</p><p class="clinic-examples">This includes, but is not limited to, use by physical therapists, athletic trainers and hospitals.</p></section><div class="result-cta clinic-cta"><a class="button" id="sqv8v3-clinic-email" href="${emailLink}">Ask about Squid Go Pro${icon("arrow")}</a><a class="clinic-address" href="${emailLink}">${SUPPORT_EMAIL}</a><p>Our team replies Monday to Friday, 9 a.m. to 6 p.m. Eastern Time (ET).</p><button type="button" class="inline-button contact-text" data-contact aria-haspopup="dialog" aria-controls="sqv8v3-contact-dialog">More contact options</button></div><div style="text-align:center;margin-top:22px"><button type="button" class="text-button" id="sqv8v3-clinic-restart">Start again</button></div>`;
          byId("clinic-edit").addEventListener("click", () => {
            state.step = flow().findIndex((q) => q.id === "profile");
            renderQuestion();
          });
          byId("clinic-restart").addEventListener("click", () => {
            state.answers = {};
            state.sizing = emptySizing();
            state.step = 0;
            if (emailOffer) {
              emailHome.append(emailOffer);
              emailOffer.hidden = true;
            }
            result.replaceChildren();
            quiz.replaceChildren();
            display(intro, "intro-title");
          });
          display(result, "result-title");
        }
        function renderResult() {
          const unanswered = flow().findIndex((q) =>
            q.id === "fit" ? !fitCanContinue() : !state.answers[q.id],
          );
          if (unanswered !== -1) {
            state.step = unanswered;
            renderQuestion();
            return;
          }
          if (state.answers.profile === "clinic") {
            renderClinicReferral();
            return;
          }
          if (emailOffer) emailHome.append(emailOffer);
          const a = state.answers,
            p = PRODUCTS[a.area],
            owner = a.experience === "owner",
            fit = fitOutcome(),
            variant = variantLabel(fit),
            needsHelp = owner || !p || !fit.resolved,
            profile = PROFILE_COPY[a.profile];
          const productUrl = p
            ? productUrls[a.area] || STORE + "/products/" + p.handle
            : COLLECTION;
          const title = owner
            ? "Build on your current system."
            : !p
              ? "Let’s find the right wrap."
              : fit.resolved
                ? "Your Squid Go match."
                : "Let’s double-check the fit.";
          const introCopy = owner
            ? "Check the right wrap, gel pack or part for the system you already own."
            : !p
              ? "Our team can help you explore the body-area and fit options."
              : fit.resolved
                ? "Your system and fit, together in one place."
                : "You have a body area in mind. Your size or side needs a quick check before ordering.";
          const sideHint =
            a.area === "shoulder"
              ? "Choose the size and shoulder side separately."
              : a.area === "leg"
                ? "The same wrap fits either leg."
                : a.area === "ankle"
                  ? "The same wrap fits either ankle."
                  : ["wrist", "elbow"].includes(a.area)
                    ? "The same wrap fits either side."
                    : "";
          const productCard = p
            ? `<div class="result-card"><div class="result-main"><div class="result-art">${areaArt(a.area)}</div><div class="result-product"><h3>${owner ? p.label + " wrap / accessory" : p.name}<strong class="variant-name">${escape(variant)}</strong></h3><p class="variant-context">${escape(fit.detail)}</p><div class="variant-actions">${SIZED_AREAS.includes(a.area) ? '<button type="button" class="inline-button" id="sqv8v3-edit-fit">Change fit answers</button>' : ""}${needsHelp ? '<button type="button" class="inline-button" data-contact aria-haspopup="dialog" aria-controls="sqv8v3-contact-dialog">Check with our team</button>' : ""}</div></div></div></div>`
            : `<div class="result-card"><div class="result-main"><div class="result-art"><span class="area-art">${icon("person")}</span></div><div class="result-product"><h3>Get help choosing</h3><p>Tell our team which area you have in mind and any fit questions.</p></div></div></div>`;
          const mainAction = needsHelp
            ? `<button type="button" class="button" data-contact aria-haspopup="dialog" aria-controls="sqv8v3-contact-dialog">${owner ? "Ask about a wrap or part" : "Confirm my fit with the team"}${icon("arrow")}</button>`
            : `<a class="button" id="sqv8v3-view-system" href="${productUrl}" target="_blank" rel="noopener noreferrer">View my ${p.label.toLowerCase()} system${icon("arrow")}</a>`;
          const choice =
            fit.resolved && p && !owner
              ? SIZED_AREAS.includes(a.area)
                ? `Select <strong>${escape(fit.size)}</strong>${a.area === "shoulder" ? ` and <strong>${state.sizing.side === "left" ? "Left" : "Right"}</strong>` : ""} on the product page.`
                : "<strong>One size fits most.</strong> Check the fit details on the product page."
              : "";
          const cta = `<div class="result-cta">${mainAction}${choice ? `<p class="selection-reminder">${choice}</p><p class="new-tab-note">The product opens in a new tab so you can keep this guide.</p>` : `<p>${escape(fit.resolved ? "Our team can help check compatibility." : "We won’t guess a size or side when the chart doesn’t give a clear answer.")}</p>`}${needsHelp ? `<a href="${productUrl}" target="_blank" rel="noopener noreferrer">${p ? "View the system and size chart" : "Browse the systems"} ↗</a>` : '<button type="button" class="inline-button contact-text" data-contact aria-haspopup="dialog" aria-controls="sqv8v3-contact-dialog">Ask a question before buying</button>'}</div>`;
          const compression =
            a.area === "shoulder"
              ? "The gel pack provides the cold. The connected pump inflates the shoulder wrap, which applies non-sequential compression."
              : p
                ? "The gel pack provides the cold. The connected pump inflates the wrap, which applies intermittent sequential compression."
                : "The gel pack provides the cold. The pump inflates the wrap to apply compression. The shoulder wrap uses a non-sequential pattern.";
          const routine = {
            home: "Prepare the gel pack in your freezer, charge the pump and choose a comfortable seat.",
            desk: "Prepare the gel pack and charge the pump before your seated break. Keep the tubing clear of your chair.",
            away: "Bring a charged pump and plan how to keep the gel pack cold. You’ll need a freezer to refreeze it.",
          }[a.routine];
          const faqs = [
            {
              title: "How does the compression work?",
              body:
                compression +
                (a.area === "shoulder"
                  ? " Squid Go explains that the shoulder is close to the heart, so it does not need the sequential pattern used to move swelling from the extremities toward the heart."
                  : " Air chambers in the wrap apply the compression."),
            },
            {
              title: "How do I set it up?",
              body: "Freeze the gel pack, fit it inside the wrap and connect the wrap to the charged pump using the tube. Follow the supplied preparation and fitting instructions. Refreeze the pack before your next cold session.",
            },
            {
              title: "Can I check the size guide again?",
              body: p
                ? `${sizingChart(a.area)}${SIZED_AREAS.includes(a.area) ? "<p>If your measurement is between the listed ranges or outside the chart, ask our team before choosing.</p>" : ""}`
                : "Choose a body area first or ask our team for guidance.",
            },
            {
              title: "Can I ask someone before buying?",
              body: 'Of course. <button type="button" class="inline-button" data-contact aria-haspopup="dialog" aria-controls="sqv8v3-contact-dialog">Contact our team</button> with your fit or product questions. Or request your 7% code below and reply when the email arrives.',
            },
          ];
          if (p && !SIZED_AREAS.includes(a.area))
            faqs[2].body =
              "One size fits most. " +
              sideHint +
              " Check the product page for fitting guidance.";
          if (owner)
            faqs.unshift({
              title: "Do I need another full system?",
              body: "You may only need an accessory. Tell our team which system and wrap you already own so they can check compatibility. The full-system contents shown above do not describe a separately purchased accessory.",
            });
          state.videoKind = "system";
          state.videoArea = p ? a.area : "leg";
          result.innerHTML = `<div class="result-top"><span class="completed">${icon("check")}Your guide</span><button type="button" class="text-button" id="sqv8v3-edit">Edit my answers</button></div><div class="result-header"><h2 id="sqv8v3-result-title">${title}</h2><p>${introCopy}</p></div>${productCard}${purchaseBenefits(!owner)}${cta}<div class="tailored routine-summary"><div><h3>${icon(QUESTIONS.profile.options.find((o) => o.value === a.profile).icon)}${profile.heading}</h3><p><strong>${escape(selectedLabel("routine"))}:</strong> ${routine}${["recovery", "care"].includes(a.profile) ? " " + profile.text : ""}</p></div></div>${boxContents(a.area)}${videoSection(a.area)}<div class="result-details">${faqs.map((f) => `<details><summary>${f.title}</summary><div class="detail-body">${f.body}</div></details>`).join("")}</div>${reviewsSection()}<div data-email-slot></div><p class="result-boundary">This guide helps you choose a product and check fit. For medical suitability, follow the product instructions and speak with your clinician.</p><div style="text-align:center;margin-top:12px"><button type="button" class="text-button" id="sqv8v3-restart">Start again</button></div>`;
          if (emailOffer) {
            result.querySelector("[data-email-slot]").append(emailOffer);
            emailOffer.hidden = false;
          }
          byId("edit").addEventListener("click", () => {
            state.step = 0;
            renderQuestion();
          });
          byId("edit-fit")?.addEventListener("click", () => {
            state.step = flow().findIndex((q) => q.id === "fit");
            renderQuestion();
          });
          byId("restart").addEventListener("click", () => {
            state.answers = {};
            state.sizing = emptySizing();
            state.step = 0;
            if (emailOffer) {
              emailHome.append(emailOffer);
              emailOffer.hidden = true;
            }
            result.replaceChildren();
            quiz.replaceChildren();
            display(intro, "intro-title");
          });
          root.querySelectorAll("[data-video]").forEach((b) =>
            b.addEventListener("click", () => {
              state.videoKind = b.dataset.video;
              showVideo();
            }),
          );
          byId("video-system").addEventListener("change", (event) => {
            state.videoArea = event.target.value;
            showVideo();
          });
          display(result, "result-title");
          showVideo();
        }
        function resetCopyButton() {
          clearTimeout(copyResetTimer);
          copyEmailButton.disabled = false;
          copyEmailButton.dataset.state = "ready";
          byId("copy-label").textContent = "Copy email";
          byId("copy-error").textContent = "";
        }
        function fallbackCopy() {
          const field = document.createElement("textarea");
          field.value = SUPPORT_EMAIL;
          field.className = "copy-fallback";
          field.setAttribute("readonly", "");
          field.setAttribute("aria-label", "Support email to copy");
          contact.append(field);
          field.focus();
          field.select();
          field.setSelectionRange(0, field.value.length);
          let copied = false;
          try {
            copied = document.execCommand("copy");
          } catch (error) {
            copied = false;
          }
          field.remove();
          copyEmailButton.focus({
            preventScroll: true,
          });
          return copied;
        }
        copyEmailButton.addEventListener("click", async () => {
          if (copyEmailButton.disabled) return;
          clearTimeout(copyResetTimer);
          const operation = ++copyOperation;
          copyEmailButton.disabled = true;
          byId("copy-error").textContent = "";
          let copied = false;
          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(SUPPORT_EMAIL);
              copied = true;
            } else {
              copied = fallbackCopy();
            }
          } catch (error) {
            if (contact.open && operation === copyOperation)
              copied = fallbackCopy();
          }
          if (operation !== copyOperation || !contact.open) return;
          copyEmailButton.disabled = false;
          if (copied) {
            copyEmailButton.dataset.state = "copied";
            byId("copy-label").textContent = "Copied";
            copyResetTimer = setTimeout(resetCopyButton, 3000);
          } else {
            copyEmailButton.dataset.state = "ready";
            byId("copy-label").textContent = "Copy email";
            byId("copy-error").textContent =
              "Couldn’t copy automatically. Select the email address above to copy it.";
          }
        });
        root.addEventListener("click", (event) => {
          const reviewButton = event.target.closest("[data-review]");
          if (reviewButton) {
            const review = REVIEWS[Number(reviewButton.dataset.review)];
            if (!review) return;
            byId("review-external").href = review.url;
            byId("review-dialog-copy").textContent =
              `${review.name}’s full review opens on Trustpilot in a new tab. Your quiz result stays here.`;
            reviewsDialog.showModal();
            lockScroll();
            return;
          }
          if (event.target.closest("[data-contact]")) {
            resetCopyButton();
            contact.showModal();
            lockScroll();
            return;
          }
          if (!event.target.closest("[data-trial-details]")) return;
          const product = PRODUCTS[state.answers.area];
          const productLink = byId("terms-product-link");
          productLink.href = product
            ? productUrls[state.answers.area] ||
              STORE + "/products/" + product.handle
            : COLLECTION;
          productLink.textContent = product
            ? "View " + product.label.toLowerCase() + " product details ↗"
            : "Browse systems & product details ↗";
          terms.showModal();
          lockScroll();
        });
        byId("terms-close").addEventListener("click", () => terms.close());
        byId("contact-close").addEventListener("click", () => contact.close());
        byId("review-close").addEventListener("click", () =>
          reviewsDialog.close(),
        );
        byId("review-stay").addEventListener("click", () =>
          reviewsDialog.close(),
        );
        byId("review-external").addEventListener("click", () =>
          reviewsDialog.close(),
        );
        [terms, contact, reviewsDialog].forEach((dialog) => {
          let pointerStartedOutside = false;
          const outside = (event) => {
            const box = dialog.getBoundingClientRect();
            return (
              event.clientX < box.left ||
              event.clientX > box.right ||
              event.clientY < box.top ||
              event.clientY > box.bottom
            );
          };
          dialog.addEventListener("pointerdown", (event) => {
            pointerStartedOutside = event.target === dialog && outside(event);
          });
          dialog.addEventListener("click", (event) => {
            if (
              pointerStartedOutside &&
              event.target === dialog &&
              outside(event)
            )
              dialog.close();
            pointerStartedOutside = false;
          });
          dialog.addEventListener("close", () => {
            if (!terms.open && !contact.open && !reviewsDialog.open)
              unlockScroll();
          });
        });
        contact.addEventListener("close", () => {
          copyOperation++;
          resetCopyButton();
        });
        byId("start").addEventListener("click", () => {
          state.step = 0;
          renderQuestion();
        });
        this.cleanup = () => {
          window.removeEventListener("pageshow", this.onPageShow);
          copyOperation++;
          clearTimeout(copyResetTimer);
          stopVideo();
          [terms, contact, reviewsDialog].forEach((dialog) => {
            if (dialog.open) dialog.close();
          });
          unlockScroll();
        };

        const emailForm = emailOffer?.querySelector("form");
        const emailButton = emailOffer?.querySelector("[data-email-submit]");
        const emailButtonLabel = emailOffer?.querySelector(
          "[data-email-button-label]",
        );
        const confirmation = emailOffer?.querySelector(
          "[data-email-confirmation]",
        );
        const emailFields = emailOffer?.querySelector("[data-email-fields]");
        const emailProgress = emailOffer?.querySelector(
          "[data-email-progress]",
        );
        const serverSuccess = confirmation?.dataset.formResult === "success";
        const serverError = emailOffer?.querySelector(
          '[data-form-result="error"]',
        );
        let sending = false;
        function setSending(value) {
          if (!emailForm || requestSent) return;
          sending = value;
          emailOffer.dataset.emailState = value ? "sending" : "ready";
          emailButton.disabled = value;
          emailButtonLabel.textContent = value
            ? "Sending request…"
            : "Email me my code";
          emailForm.setAttribute("aria-busy", String(value));
          emailProgress.textContent = value ? "Sending your request…" : "";
        }
        function showSentConfirmation() {
          if (!emailForm) return;
          requestSent = true;
          sending = false;
          emailOffer.dataset.emailState = "sent";
          emailOffer.querySelector("h3").textContent = "Your 7% code request";
          emailFields.hidden = true;
          confirmation.hidden = false;
          emailForm.setAttribute("aria-busy", "false");
          emailProgress.textContent = "";
          saveProgress();
        }
        emailForm?.addEventListener("submit", (event) => {
          saveProgress();
          if (requestSent || sending) {
            event.preventDefault();
            return;
          }
          queueMicrotask(() => {
            if (!event.defaultPrevented && root.isConnected) setSending(true);
          });
        });
        root.addEventListener("change", saveProgress);
        root.addEventListener("input", (event) => {
          if (event.target.id !== "sqv8v3-discount-email") saveProgress();
        });
        this.onPageShow = () => {
          if (!requestSent) setSending(false);
        };
        window.addEventListener("pageshow", this.onPageShow);
        const saved = readProgress();
        if (saved) {
          state.answers = saved.answers;
          state.sizing = saved.sizing;
          state.step = Math.max(0, Math.min(saved.step, flow().length - 1));
          requestSent = saved.requestSent;
          if (saved.screen === "result") renderResult();
          else if (saved.screen === "quiz") renderQuestion();
        }
        if (serverError) requestSent = false;
        if (serverSuccess || requestSent) showSentConfirmation();
        if (serverSuccess || serverError) {
          emailOffer.hidden = false;
          requestAnimationFrame(() => {
            const message = serverSuccess ? confirmation : serverError;
            message.scrollIntoView({ block: "center" });
            message.focus({ preventScroll: true });
          });
        }
      }
      disconnectedCallback() {
        this.cleanup?.();
      }
    },
  );
}

  } catch(e) { console.error(e); }
})();
})();
